import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { logOut } from "../auth/authActions";
import ReportSummary from "../components/dashboard/ReportSummary";
import ReportLoadingIndicator from "../components/dashboard/ReportLoadingIndicator";
import { pipe, filter, length } from "ramda";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import makeStyles from "@mui/styles/makeStyles";
import { useOrganizations } from "../user-admin/userServices";

const useStyles = makeStyles(theme => ({
  addButton: {
    fontSize: "1.2rem",
    lineHeight: "1.6rem",
    fontWeight: "bold",
  },

  addLink: {
    color: theme.palette.primary.main,
  },
}));

const getActiveCount = pipe(
  filter(org => org.active),
  length,
);

const OrganizationsReport = () => {
  const classes = useStyles();
  const reduxDispatch = useDispatch();

  const results = useOrganizations();
  useEffect(() => {
    if (results.isError) {
      //-- Send user to login if the token has expired or not logged in
      if (results.error.status === 401) {
        reduxDispatch(logOut());
      }
    }
  }, [results.isError, results.error, reduxDispatch]);

  return (
    <Fragment>
      {results.isSuccess ? (
        <ReportSummary
          primary="Active Organizations"
          secondary="All organizations within BiblioBoard"
          count={getActiveCount(results.data)}
          action={
            <Button
              size="small"
              classes={{
                textSizeSmall: classes.addButton,
                iconSizeSmall: classes.addButton,
              }}
              variant="text"
              color="primary"
              startIcon={<AddIcon fontSize="small" />}
            >
              <Link
                className={classes.addLink}
                to={{ pathname: "/manage-organizations" }}
              >
                Add New
              </Link>
            </Button>
          }
        />
      ) : (
        <ReportLoadingIndicator />
      )}
    </Fragment>
  );
};

export default OrganizationsReport;
